import { toQuery } from 'src/shared/api/crudApi';
import { httpClient } from 'src/shared/api/httpClient';
import { API_PREFIX } from 'src/shared/constants';
import type { FinanceRange, FinanceSummary } from './types';

export const financeApi = {
  /** Net takings, expenses and the result of a range. Behind `finance:read`. */
  summary: (range: FinanceRange) =>
    httpClient.get<FinanceSummary>(`${API_PREFIX}/finance/summary?${toQuery(range)}`),
};
